import Rails from 'rails-ujs';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'checkBox', 'isListedOnFlie', 'adApprovalConfirmed' ]

  onCheck() {
    if (this.checkBoxTarget.checked){
      if (confirm('[Smaview] 登録してよろしいですか？')){
        this.setSmaviewAvailable();
      } else {
        this.checkBoxTarget.checked = false;
      }
    } else {
      if (confirm('[Smaview] 解除してよろしいですか？')){
        this.setSmaviewAvailable();
      } else {
        this.checkBoxTarget.checked = true;
      }
    }
  }

  setSmaviewAvailable(){
    Rails.ajax({
      type: 'PATCH',
      dataType: 'json',
      url: `/api/estates/${ this.checkBoxTarget.defaultValue }/update_smaview_available?smaview_available=${ this.checkBoxTarget.checked }`,
      success: (json) => {
        if (json.smaview_available) {
          alert('[Smaview] 登録しました');
        } else {
          alert('[Smaview] 解除しました');
        }
      },
      error: () => {
        alert('エラーが発生しました。ブラウザをリロードして、再度お試しください。');
      }
    });
  }

  handleIsListedOnFlieChange() {
    if (this.isListedOnFlieTarget.checked) {
      if (confirm('FLIEの掲載状態を有効にしますか？')) {
        this.updateIsListedOnFlie();
      } else {
        this.isListedOnFlieTarget.checked = false;
      }
    } else {
      if (confirm('FLIEの掲載状態を無効にしますか？')) {
        this.updateIsListedOnFlie();
      } else {
        this.isListedOnFlieTarget.checked = true;
      }
    }
  }

  updateIsListedOnFlie() {
    const estateId = this.isListedOnFlieTarget.defaultValue;
    const isListedOnFlie = this.isListedOnFlieTarget.checked;

    let formData = new FormData();
    formData.append('is_listed_on_flie', isListedOnFlie);

    Rails.ajax({
      type: 'PATCH',
      dataType: 'json',
      url: `/api/estates/${estateId}/update_is_listed_on_flie`,
      data: formData,
      contentType: 'application/json',
      success: (json) => {
        alert(`FLIEの掲載状態を${json.is_listed_on_flie ? '有効' : '無効'}にしました`);
      },
      error: () => {
        alert('エラーが発生しました。ブラウザをリロードして、再度お試しください。');
      }
    });
  }

  handleAdApprovalChange() {
    if (this.adApprovalConfirmedTarget.checked) {
      if (confirm('掲載承諾を有効にしますか？')) {
        this.updateAdApprovalConfirmed();
      } else {
        this.adApprovalConfirmedTarget.checked = false;
      }
    } else {
      if (confirm('掲載承諾を無効にしますか？')) {
        this.updateAdApprovalConfirmed();
      } else {
        this.adApprovalConfirmedTarget.checked = true;
      }
    }
  }

  updateAdApprovalConfirmed() {
    const estateId = this.adApprovalConfirmedTarget.defaultValue;
    const adApprovalConfirmed = this.adApprovalConfirmedTarget.checked;

    let formData = new FormData();
    formData.append('ad_approval_confirmed', adApprovalConfirmed);

    Rails.ajax({
      type: 'PATCH',
      dataType: 'json',
      url: `/api/estates/${estateId}/update_ad_approval_confirmed`,
      data: formData,
      contentType: 'application/json',
      success: (json) => {
        alert(`掲載承諾を${json.ad_approval_confirmed ? '有効' : '無効'}にしました`);
      },
      error: (xhr) => {
        // チェックボックスの状態を元に戻す
        this.adApprovalConfirmedTarget.checked = !adApprovalConfirmed;

        // HTTPステータスに応じたエラーメッセージを表示
        if (xhr.status === 401) {
          alert('編集権限がありません。管理者のみが掲載承諾を変更できます。');
        } else if (xhr.status === 404) {
          alert('物件が見つかりませんでした。ページをリロードしてください。');
        } else if (xhr.status === 422) {
          alert('更新に失敗しました。入力内容を確認してください。');
        } else {
          alert('エラーが発生しました。ブラウザをリロードして、再度お試しください。');
        }
      }
    });
  }
}
